import React from 'react'
import styled from 'styled-components'
import { array } from 'prop-types'
import { rgba, stripUnit } from 'polished'
import { Link } from 'gatsby'

import * as spacing from 'styles/spacing'
import { white, borderColor, greyDark } from 'styles/colors'
import { animationTime, animationCurve, summaryHeight } from 'styles/global'
import { media } from 'styles/media'
import { H4, fontSizes, fontWeights } from 'styles/typography'

const Container = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-shrink: 0;
  z-index: 10;
  align-items: center;
  background-color: ${white};
  border-top: 1px solid ${borderColor};
  height: ${summaryHeight};

  @media only screen and (max-height: 705px) {
    display: none;
  }
`

const Inner = styled.div`
  padding: 0 ${spacing.xLarge};

  ${media.xLarge`
    padding: 0 ${spacing.xxLarge};
  `};
`

const Heading = styled(H4)`
  font-weight: ${fontWeights.medium};
  margin-bottom: ${spacing.medium};
`

const List = styled.div`
  display: flex;
`

const Product = styled(Link)`
  display: inline-block;
  font-size: ${fontSizes.tiny};
  color: ${greyDark};
  font-weight: ${fontWeights.medium};
  padding: ${spacing.small} ${spacing.medium};
  border-radius: ${spacing.xLarge};
  background-color: ${rgba(borderColor, 0.35)};
  transition: background-color ${animationTime} ${animationCurve};

  ${media.xLarge`
    padding-left: ${spacing.large};
    padding-right: ${spacing.large};
  `};

  &:hover {
    background-color: ${rgba(borderColor, 0.55)};
  }

  & + & {
    margin-left: ${stripUnit(spacing.small) * 1.5 + 'px'};

    ${media.xLarge`
      margin-left: ${spacing.medium};
    `};
  }
`

const RelatedProducts = ({ products }) => (
  <Container className="u-hide-large-down">
    <Inner>
      <Heading>Our other products</Heading>
      <List>
        {products.map((product, i) => (
          <Product to={product.link} key={i}>
            {product.name}
          </Product>
        ))}
      </List>
    </Inner>
  </Container>
)

RelatedProducts.propTypes = {
  products: array.isRequired
}

export default RelatedProducts
